'use strict';
angular.module('iWoManuscriptCollectionModule', []).controller('iWoManuscriptCollectionCtrl', [
    '$scope',
    '$q',
    '$state',
    '$window',
    'initSingleSelecet',
    '$stateParams',
    'trsHttpService',
    'modalDialog',
    'trsspliceString',
    'editcenterRightsService',
    'editingCenterService',
    'storageListenerService',
    'globleParamsSet',
    function(
        $scope,
        $q,
        $state,
        $window,
        initSingleSelecet,
        $stateParams,
        trsHttpService,
        modalDialog,
        trsspliceString,
        editcenterRightsService,
        editingCenterService,
        storageListenerService,
        globleParamsSet,
        editingMediatypeToPlat
    ) {

        /**
         * [exportDraft description:数据请求方法]
         */
        $scope.requestData = function() {
            // 判断是否启用ES检索
            var params = $scope.status.isESSearch ? getESSearchParams() : angular.copy($scope.params);
            $scope.status.isESSearch = false; // 防止再次使用海贝检索
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.items = data.DATA;
                var ListItems = data.DATA;
                !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = '0');
                $scope.data.selectedArray = [];
                requestListImg(ListItems).then(function(data) {
                    angular.forEach(ListItems, function(value, key) {
                        value.ALLIMG = data[value.MLFID];
                    });
                });
            });
        };
        initStatus();
        initData();

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenIwo(function() {
                $scope.requestData();
                storageListenerService.removeListener('iwo');
            }, $scope);
        }

        /**
         * [requestListImg description:查询列表图示]
         */
        function requestListImg(items) {
            var defer = $q.defer();
            if (!items || items.length < 1) {
                defer.resolve([]);
            } else {
                var params = {
                    serviceid: 'mlf_myrelease',
                    methodname: 'queryAllImgLogo',
                    metadataids: trsspliceString.spliceString(items, 'MLFID', ','),
                    DocCollect: true,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        /**
         * [exportDraft description:下拉框筛选]
         */
        $scope.queryByDropdown = function(key, selected) {
            $scope.params[key] = selected.value;
            $scope.params.CurrPage = $scope.status.copyCurrPage = $scope.page.CURRPAGE = '1';
            $scope.requestData();
        };
        
        /**
         * [promptRequest description]具体操作数据请求成功后刷新列表
         * @param  {[obj]} params [description]请求参数
         * @param  {[string]} info   [description]提示语
         * @return {[type]}        [description]
         */
        function promptRequest(params, info) {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType(info, '', 'success', false, function() {
                    $scope.requestData();
                });
            });
        }

        /**
         * [exportDraft description:下一页]
         */
        $scope.pageChanged = function() {
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            $scope.requestData();
        };

        /**
         * [exportDraft description:跳转至指定页面]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.params.CurrPage = $scope.status.copyCurrPage;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            $scope.requestData();
        };

        /**
         * [exportDraft description:全选]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [exportDraft description:单选]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [exportDraft description:初始化数据]
         */
        function initData() {
            $scope.requestData();
            iWoListBtn();
            initDropDown();
            listenStorage();
        }

        /**
         * [exportDraft description:初始化状态]
         */
        function initStatus() {
            $scope.status = {
                batchOperateBtn: {
                    hoverStatus: '',
                    clickStatus: '',
                },
                icon: {
                    noVideo: '0',
                    noAudio: '0',
                    noPic: '0',
                },
                btnRights: [],
                isESSearch: false,
                draftType: {
                    news: '1',
                    atlas: '2',
                    subject: '3',
                    linkDoc: '4',
                    activity: '5',
                    topic: '6',
                    video: '7',
                    live: '8',
                },
            };
            $scope.data = {
                selectedArray: [],
                preview: {
                    '1': 'iWoNewsPreview',
                    '2': 'iWoAtlasPreview',
                },
                docPic: {
                    '1': '新闻',
                    '2': '图集',
                },
                id: {
                    siteid: $stateParams.siteid,
                    channelid: $stateParams.channelid,
                },
                dropDown: {
                    iWoSelectedAll: '',
                    iWoEntireJsons: '',
                    iWoDocSelected: '',
                    docTypeJsons: '',
                    collectTimeSelected: '',
                    collectTimeJsons: '',
                    createTimeSelected: '',
                    createTimeJsons: '',
                },
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.getPageSize(),
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.status.copyCurrPage = 1;
            $scope.params = {
                serviceid: 'mlf_myrelease',
                methodname: 'queryCollections',
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE,
                DocType: '',
                CrTime: '',
                CoTime: '',
            };
        }

        /**
         * [exportDraft description:初始化权限按钮]
         */
        function iWoListBtn() {
            editcenterRightsService.initIwoListBtn('iwo.collect').then(function(rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [exportDraft description:初始化下拉框的数据]
         */
        function initDropDown() {
            // 下拉框单选
            initSingleSelecet.channelStatus().then(function(data) {
                $scope.iWotest = data;
            });
            // ES类型选择
            $scope.data.dropDown.iWoEntireJsons = initSingleSelecet.ManuCollEntire();
            $scope.data.dropDown.iWoSelectedAll = angular.copy($scope.data.dropDown.iWoEntireJsons[0]);
            // 选择类型
            $scope.data.dropDown.docTypeJsons = initSingleSelecet.docType();
            $scope.data.dropDown.iWoDocSelected = angular.copy($scope.data.dropDown.docTypeJsons[0]);
            // 收藏时间
            $scope.data.dropDown.collectTimeJsons = initSingleSelecet.iWoCollect();
            $scope.data.dropDown.collectTimeSelected = angular.copy($scope.data.dropDown.collectTimeJsons[0]);
            // 创建时间
            $scope.data.dropDown.createTimeJsons = initSingleSelecet.iWoCollectCreatTime();
            $scope.data.dropDown.createTimeSelected = angular.copy($scope.data.dropDown.createTimeJsons[0]);
            // 排序方式
            $scope.sortTypeJsons = initSingleSelecet.sortType();
            $scope.sortType = angular.copy($scope.sortTypeJsons[1]);
        }

        /**
         * [exportDraft description:删除稿件的方法]
         */
        $scope.deleteTit = function() {
            $scope.status.isESSearch = false;
            var MetaDataIds = trsspliceString.spliceString($scope.data.selectedArray, 'DOCCOLLECTRELID', ',');
            delectDoc(MetaDataIds);
        };

        /**
         * [exportDraft description:删除稿件的方法]
         * @param  {[string]} items [description]所选稿件的DOCCOLLECTRELID集合
         */
        function delectDoc(ChnlDocIds) {
            modalDialog.inputModel('取消收藏', '取消收藏原因（选填）', function(content) {
                var params = {
                    serviceid: 'mlf_myrelease',
                    methodname: 'delCollections',
                    Ids: ChnlDocIds,
                };
                promptRequest(params, '取消收藏成功');
            });
        }

        /**
         * [exportDraft description:选择单页显示个数]
         */
        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            $scope.params.PageSize = $scope.page.PAGESIZE;
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.requestData();
        };

        /**
         * [exportDraft description:单个复制稿件]
         * @param  {[obj]} item [description]单条稿件项
         */
        $scope.copyBuildDraft = function(item) {
            $scope.status.isESSearch = false;
            copyBuildDraft([item]);
        };

        /**
         * [exportDraft description:批量复制稿件]
         */
        $scope.batchCopyBuildDraft = function() {
            modalDialog.alertType('确定复制到个人稿库？', '', 'ask', true, function() {
                $scope.status.isESSearch = false;
                copyBuildDraft($scope.data.selectedArray);
            });
        };

        /**
         * [exportDraft description:复制稿件方法]
         */
        function copyBuildDraft(array) {
            var params = {
                serviceid: 'mlf_fusionmyrelease',
                methodname: 'fusionCopyCollection',
                Ids: trsspliceString.spliceString(array, 'DOCCOLLECTRELID', ','),
            };
            promptRequest(params, '复制成功');
        }

        /**
         * [checkDraftType description：检查是否选中了某种类型的稿件]
         * @params typeId 稿件ID
         * return 若有该类型则返回true
         */
        function checkDraftType(typeId) {
            var flag = false;
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if ($scope.data.selectedArray[i].DOCTYPEID == typeId) {
                    flag = true;
                    break;
                }
            }
            return flag;
        }

        /**
         * [exportDraft description:导出稿件]
         */
        $scope.exportDraft = function() {
            $scope.status.isESSearch = false;
            if (!checkDraftType($scope.status.draftType.news) && !checkDraftType($scope.status.draftType.atlas)) {
                modalDialog.alertType('只能导出新闻稿或图集稿', '', 'error', false);
                return;
            }
            var params = {
                serviceid: 'mlf_exportword',
                methodname: 'exportCollectedDocs',
                DOCCOLLECTRELIDS: trsspliceString.spliceString($scope.data.selectedArray, 'DOCCOLLECTRELID', ','),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                // window.open(data);
                window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
            });
        };

        /**
         * [exportDraft description:邮件外发]
         */
        $scope.outSending = function() {
            $scope.status.isESSearch = false;
            editingCenterService.outSending('', function(result) {
                outSendingDraft(result.selectItems);
            });
        };

        /**
         * [exportDraft description:邮件外发]
         * @param  {[obj]} items [description]所选的需要外发的邮箱
         */
        function outSendingDraft(items) {
            var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
            var draftids = trsspliceString.spliceString($scope.data.selectedArray, 'DOCCOLLECTRELID', ',');
            var params = {
                serviceid: 'mlf_mailoutgoingOper',
                methodname: 'iColletionSendEmail',
                Emails: userids,
                doccollectrelids: draftids,
            };
            promptRequest(params, '邮件外发成功');
        }

        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.status.isESSearch = true;
                $scope.requestData();
            }
        };

        /**
         * [getESSearchParams description]设置ES检索参数
         * @return {[json]} [description] 参数对象
         */
        function getESSearchParams() {
            var esParams = {
                serviceid: 'mlf_hybasesearch',
                methodname: 'queryForIwoCollectDoc',
                searchParams: {
                    PAGESIZE: $scope.page.PAGESIZE + '',
                    PAGEINDEX: $scope.page.CURRPAGE + '',
                    searchFields: [
                        {
                            searchField: $scope.data.dropDown.iWoSelectedAll.value,
                            keywords: $scope.keywords ? $scope.keywords : '',
                        },
                        {
                            searchField: 'docType',
                            keywords: $scope.data.dropDown.iWoDocSelected.value, // 稿件类型
                        },
                        {
                            searchField: 'collectTimeType',
                            keywords:
                                angular.isDefined($scope.params.CollectTimeStart) && $scope.params.CollectTimeStart !== ''
                                    ? $scope.params.CollectTimeStart + ',' + $scope.params.CollectTimeEnd
                                    : $scope.data.dropDown.collectTimeSelected.value, // 收藏时间
                        },
                        {
                            searchField: 'createTimeType',
                            keywords:
                                angular.isDefined($scope.params.CreateTimeStart) && $scope.params.CreateTimeStart !== ''
                                    ? $scope.params.CreateTimeStart + ',' + $scope.params.CreateTimeEnd
                                    : $scope.data.dropDown.createTimeSelected.value, // 创建时间
                        },
                        {
                            searchField: '_sort',
                            keywords: $scope.sortType.value,
                        },
                    ],
                },
            };
            esParams.searchParams = JSON.stringify(esParams.searchParams);
            return esParams;
        }

        /**
         * [fusionPreview description] 跳转查看页
         *
         * @param   {[type]}  doctype        [doctype description]
         * @param   {[type]}  iwometadataid  [iwometadataid description]
         * @param   {[type]}  iwochnldocid   [iwochnldocid description]
         * @param   {[type]}  mlftype        [mlftype description]
         * @param   {[type]}  collectid      [collectid description]
         *
         * @return  {[type]}                 [return description]
         */
        // $scope.fusionPreview = function(doctype, iwometadataid, iwochnldocid, mlftype, collectid) {
        //     // collect
        //     storageListenerService.previewPageTurningStorage($scope.data.items, 'DOCTYPEID,MLFID,CHNLDOCID,MLFTYPE,DOCCOLLECTRELID', 'fusionPreview');
        //     var url,
        //         routerParams = {
        //             iwotype: doctype,
        //             iwomodalname: 'iwo.collect',
        //             wzplatform: 0,
        //             wztypeid: doctype,
        //             appplatform: 0,
        //             newspapertype: 2,
        //             iwometadataid: iwometadataid,
        //             iwochnldocid: iwochnldocid,
        //             mlftype: mlftype, // 是否来自资源中心
        //             iwodoccollectrelid: collectid,
        //         };

        //     routerParams.appdoctype = doctype;
        //     if (mlftype == 0) {
        //         // coc
        //         getBindingMediaIds(iwometadataid).then(function(bingdingData) {
        //             angular.forEach(bingdingData, function(value, key) {
        //                 if (value.MEDIATYPE == '1') {
        //                     routerParams.appsiteid = value.SITEID;
        //                     routerParams.appchannelid = value.CHANNELID;
        //                     routerParams.appchnldocid = value.CHNLDOCID;
        //                     routerParams.appmetadataid = value.VIRTUALDOCID;
        //                 } else if (value.MEDIATYPE == '2') {
        //                     routerParams.wzsiteid = value.SITEID;
        //                     routerParams.wzchannelid = value.CHANNELID;
        //                     routerParams.wzchnldocid = value.CHNLDOCID;
        //                     routerParams.wzmetadataid = value.VIRTUALDOCID;
        //                 } else if (value.MEDIATYPE == '3') {
        //                     routerParams.paperid = value.CHANNELID; // 预览页与编辑页参数不同
        //                     routerParams.bzmetadata = value.VIRTUALDOCID; // 预览页与编辑页参数不同
        //                 }
        //             });
        //             url = $state.href('fusionpreview', routerParams);
        //             window.open(url);
        //         });
        //     } else {
        //         url = $state.href('fusionpreview', routerParams);
        //         window.open(url);
        //     }
        // };


        /**
         * [routerToPrevie description]跳转到对应渠道的查看页
         * @param   {[obj]}  item  [item description]稿件信息
         * @return  {[type]}       [return description]
         */
        $scope.routerToPreview = function(item) {
            var params = {};
            var path = '';
            if (item.MLFTYPE === '0') {
                // 表示来自采编
                editingCenterService.routerToPreview(item);
            } else if (item.MLFTYPE === '3') {
                path = 'resourcexhsgbigdatadetail';
                params = {
                    type: item.DOCTYPE,
                    docid: item.MLFID
                };
                $window.open($state.href(path, params));
            } else {
                // 表示来自大数据
                if (item.ATTRIBUTE) {
                    path = 'resourcepushdetail'; // 资源中心暂时默认跳转到这里，能满足（特色资源、网络资源、成品资源收藏来的稿件,能获取的内容只有ATTRIBUTE做区分较难）
                    var map = item.ATTRIBUTE.split('&');
                    for (var i = 0; i < map.length; i++) {
                        var mapInfo = map[i].split('=');
                        params[mapInfo[0].toLowerCase()] = mapInfo[1];
                    }
                    params.iscollect = true;
                }
                $window.open($state.href(path, params));
            }
        };
    },
]);
